import * as React from "react";

import { Box, makeStyles, Theme, Typography } from "@material-ui/core";

import { MopButton } from "client/components";
import { useBranding, useTranslation } from "client/hooks";
import { logAmplitudeEvent } from "client/lib/amplitude";

const useStyles = makeStyles((theme: Theme) => ({
  addLocationButton: {
    marginBottom: theme.spacing(2),
    minWidth: "50%",
  },
}));

export const SingleStoreFooter: React.FC<{
  onAddClick: () => void;
}> = ({ onAddClick }) => {
  const classes = useStyles();
  const t = useTranslation();

  const { brandKey } = useBranding();
  const isCash = brandKey === "CashApp";

  return (
    <Box mb={2}>
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        justifyContent="center"
      >
        <MopButton
          className={classes.addLocationButton}
          mopVariant="secondary"
          fullWidth={isCash}
          startIcon={isCash ? <Typography>+</Typography> : undefined}
          onClick={() => {
            onAddClick();
            logAmplitudeEvent(
              "REDESIGN_ADD_YOUR_STORE",
              "clicked_add_another_store_button"
            );
          }}
        >
          {t("uiStoreLocationsAddButton")}
        </MopButton>
      </Box>
    </Box>
  );
};

export const StoreLocationsHeader: React.FC = () => {
  const t = useTranslation();
  const { brandTitle } = useBranding();

  return (
    <Box width="100%" mb={2} mt={2}>
      <Typography variant="body2">
        <strong>{t("uiStoreLocationFormHeader")}</strong>
      </Typography>
      <Typography variant="body2">
        {`Tell us which stores will have ${brandTitle} added as a payment option.`}
      </Typography>
    </Box>
  );
};
